<script setup lang="ts">
defineProps<{
  title: string;
  value: string | number;
  subtitle?: string;
}>();
</script>

<template>
  <div class="card border-0 shadow-sm rounded-4 p-3 h-100 summary-card">
    <div class="summary-title text-muted tiny-text text-uppercase mb-1">
      {{ title }}
    </div>
    <div class="d-flex align-items-baseline">
      <h2 class="summary-value fw-black mb-0 display-5">
        {{ value }}
      </h2>
      <span
        v-if="subtitle"
        class="ms-2 text-muted fw-bold h4 mb-0"
      >/ {{ subtitle }}</span>
    </div>
  </div>
</template>

<style scoped>
.summary-card {
  background: white;
  border-radius: 12px !important;
}
.summary-title {
  font-weight: 500;
  letter-spacing: 0.05em;
  color: #64748b !important;
}
.tiny-text {
  font-size: 0.65rem;
}
.summary-value {
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
}
</style>
